<template>
    <div class="form-profile">
        <div>
            <div class="row no-gutters pt-2">
                <div class="col-6 pr-2">
                    <ProfilePicture
                        ref="profile-picture"
                        @uploadImage="onUploadImage($event)"
                    ></ProfilePicture>
                </div>
            </div>
            <div class="row no-gutters pt-2">
                <div class="col-6 pr-2">
                    <InputText
                        v-model="profile.firstName"
                        inputId="profile-firstname"
                        :inputLbl="lbl.myprofile.firstname"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="true"
                        :errorInfo="errorInfo[0]"/>
                </div>
                <div class="col-6 pr-2">
                    <InputText
                        v-model="profile.lastName"
                        inputId="profile-lastname"
                        :inputLbl="lbl.myprofile.lastname"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="true"
                        :errorInfo="errorInfo[1]"/>
                </div>
            </div>
            <div class="row no-gutters pt-2">
                <div class="col-6 pr-2">
                    <ContactNumber
                        v-model="profile.contactNumber"
                        inputId="profile-contactNumber"
                        :inputLbl="lbl.myprofile.changeMobileNumber"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="true"
                        :isChangeMobile="true"
                        delimeter="-"
                        @changeNumber="changeNumber()"
                        isDisabled
                        :errorInfo="errorInfo[2]"/>
                </div>
                <div class="col-6 pr-2">
                    <InputEmail
                        v-model="profile.email"
                        inputId="profile-email"
                        :inputLbl="lbl.myprofile.email"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="isShowEmailError"
                        :errorInfo="errorInfo[3]"
                        @input="validateForm()"
                        />
                </div>
            </div>
            <div v-if="isStore">
                <div class="row no-gutters pt-2">
                    <div class="col-6 pr-2">
                        <InputNumber
                            v-model="profile.StoreID"
                            inputId="profile-storeId"
                            :inputLbl="lbl.myprofile.storeId"
                            :isFirstSave="isFirstSave"
                            :isShowErrorLbl="true"
                            :errorInfo="errorInfo[4]"/>
                    </div>
                    <div class="col-6 pr-2">
                        <InputText
                            v-model="profile.StoreName"
                            inputId="profile-storeName"
                            :inputLbl="lbl.myprofile.storeName"
                            :isFirstSave="isFirstSave"
                            :isShowErrorLbl="true"
                            :errorInfo="errorInfo[5]"/>
                    </div>
                </div>
                <div class="store-type">{{ lbl.myprofile.store_type }}<span v-if="isShowError" class="require-input">{{ lbl.register.storeType_err }}</span></div>
                <div class="row no-gutters">
                    <div class="col-8 pr-2">
                        <div class="row no-gutters">
                            <div class="col-6 pr-2" v-for="(data,index) in storeTypeList" :key="index">
                                <CheckBoxProfile :textLabel="localeCode == 1033 ? data.textEN : data.textTH" :setValue="data.value" @input="onCheck(data,$event)"></CheckBoxProfile>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pb-3">
            <div class="btn-wrapper">
                <div class="btn-submit" @click="clickSubmit()">
                    {{ lbl.myprofile.btn_save }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// component
import InputText from '@/components/Input/Text.vue'
import InputNumber from '@/components/Input/Number.vue'
import InputEmail from '@/components/Input/Email.vue'
import ContactNumber from '@/components/Input/ContactNumber.vue';
import CheckBoxProfile from '@/components/Input/CheckBoxProfile.vue';
import ProfilePicture from '@/module/Profile/component/ProfilePicture.vue';

// mixin
import LocaleMixin from '@/mixin/LocaleMixin';
// model
// import { RegisterModel } from '../../Register/model/RegisterModel'
// helper
import FormHelper from '@/helper/FormHelper';
import { StoreTypeList } from '../../Register/model/RegisterModel';
import Utility from '@/helper/Utility';

export default {
    name: 'FormProfile',
    mixins: [LocaleMixin],
    components: {
        InputText,
        InputNumber,
        InputEmail,
        CheckBoxProfile,
        ContactNumber,
        ProfilePicture
    },
    props: {
        formData: { type: Object, default: null },
    },
    data: function() {
        return {
            isFirstSave: true,
            errorInfo: FormHelper.genErrorInfo(6),
            profile: null,
            storeTypeList: new StoreTypeList(),
            isStore: true,
            isShowEmailError: false,
            newImage: false,
            isShowError: false,
            oldEmail: null,
        };
    },
    created: function () {
        this.profile = this.formData;
        this.oldEmail =this.profile.email
        if (this.profile && this.profile.StoreType) {
                for (let i = 0; i < this.storeTypeList.length; i++) {
                let find = this.storeTypeList.find((item) => item.id == this.profile?.StoreType[i]?.store_id);
                if (find) find.value = true;
            }
        }
        if (this.profile.StoreID === '' && this.profile.StoreName === '') {
            this.isStore = false
        } else {
            this.isStore = true
        }
    },
    mounted: function () {
    },
    methods: {
        onCheck: function(item,check){
            item.value = check
            if (this.isStore && check) {
                this.isShowError = false
            }
        },
        validateForm: function() {
            if (this.profile.email == '' && this.oldEmail == '') {
                this.isShowEmailError = false;
                this.errorInfo[3] = {
                    isValid: true,
                    msg: ''
                }
            } else if (this.profile.email == '' && this.oldEmail != '') {
                this.isShowEmailError = true;
                this.errorInfo[3] = {
                    msg: 'กรุณากรอกอีเมล'
                }
            } else {
                this.isShowEmailError = true;
                let validateEmail = Utility.validateEmail(this.profile.email)
                if(!validateEmail) {
                    this.errorInfo[3] = {
                        isValid: false,
                        msg: 'กรุณากรอกอีเมลให้ถูกต้อง'
                    }
                }
            }
            console.log(FormHelper.validate(this.errorInfo))
            return FormHelper.validate(this.errorInfo);
        },
        changeNumber: function () {
            this.$emit('changeNumber')
        },
        clickSubmit: async function () {
            this.isFirstSave = false;

            this.profile.storeType = this.storeTypeList.filter(item => item.value);

            this.profile.merge_extendjsonstring = false;
            let storeTypeParams = this.lbl.register.storeType;
            storeTypeParams.StoreID = this.profile.StoreID
            storeTypeParams.StoreName = this.profile.StoreName
            storeTypeParams.StoreType = [];

            if (this.validateForm() && this.validateInputCheckbox()) {
                if (this.profile.storeType.length > 0) {
                    for (let i = 0; i < this.profile.storeType.length; i++) {
                        storeTypeParams.StoreType.push({
                            store_id: this.profile.storeType[i].id,
                            store_name: this.profile.storeType[i].name,
                            store_type: this.localeCode == 1033 ? this.profile.storeType[i].textEN : this.profile.storeType[i].textTH,
                        })
                    }
                    let customInfo = {
                        StoreID: this.profile.StoreID,
                        StoreName: this.profile.StoreName,
                        StoreType: storeTypeParams.StoreType,
                    }
                    this.profile.custom_info = JSON.stringify(customInfo)
                    if (this.newImage) {
                        await this.$refs['profile-picture'].onUploadImage()
                    }
                    this.$emit("onSubmitProfile", storeTypeParams);

                } else {
                    if (this.newImage) {
                        await this.$refs['profile-picture'].onUploadImage()
                    }
                    this.$emit("onSubmitProfile");
                }
            }
        },
        getProfileValue: function () {
            return this.profile;
        },
        onUploadImage: function(upload) {
            this.newImage = upload
        },
        validateInputCheckbox: function(){
            if (!this.isStore) return true;
            let storeType = this.storeTypeList.filter(item => item.value)
            if(storeType.length){
                this.isShowError = false;
                return true
            }else{
                this.isShowError = true;
                return false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "../style/MyProfile.scss";
</style>
